// Vegetable guide view chrome. The care CONTENT (per-crop prose) stays English
// for now by decision; only the surrounding labels are translated here.
const guide = {
  en: {
    'guide.searchPlaceholder': 'Search',
    'guide.noMatch': 'No vegetables match “{query}”.',
    'guide.intro': 'Simple, offline care notes for common crops.',
    'guide.allVegetables': 'All vegetables',
    'guide.selectPrompt': 'Select a vegetable to see its care guide.',
    'guide.diseaseSearchPlaceholder': 'Search diseases & pests',
    'guide.diseaseNoMatch': 'No problems match “{query}”.',
    'guide.diseaseIntro': 'Identify, treat, and prevent common garden problems.',
    'guide.allDiseases': 'All problems',
    'guide.diseaseSelectPrompt': 'Select a problem to see its guide.',
    'guide.problemCategory.disease': 'Diseases',
    'guide.problemCategory.pest': 'Pests',
    'guide.problemCategory.disorder': 'Disorders',
    'guide.overview': 'Overview',
    'guide.difficultyLabel': 'Difficulty',
    'guide.growingSeason': 'Growing season',
    'guide.timeToHarvest': 'Time to harvest',
    'guide.idealConditions': 'Ideal growing conditions',
    'guide.sun': 'Sun',
    'guide.sunlight': 'Sunlight',
    'guide.soil': 'Soil',
    'guide.temperature': 'Temperature',
    'guide.water': 'Water',
    'guide.planting': 'Planting',
    'guide.care': 'Care',
    'guide.support': 'Support',
    'guide.maintenance': 'Maintenance',
    'guide.generalTips': 'General growing tips',
    'guide.commonProblems': 'Common problems',
    'guide.good': 'Good',
    'guide.backToGuide': 'Back to guide',
    'guide.problemNotFound': 'This problem guide was not found.',
    'guide.problemWhatIsIt': 'What it is',
    'guide.problemIdentify': 'How to identify it',
    'guide.problemWhy': 'Why it happens',
    'guide.problemFix': 'How to fix it',
    'guide.problemPrevent': 'How to prevent it',
    'guide.problemPlantsAffected': 'Plants affected',
    'guide.companionPlants': 'Companion plants',
    'guide.goodCompanions': 'Good companions',
    'guide.avoid': 'Avoid',
    'guide.cropRotation': 'Crop rotation',
    'guide.family': 'Family',
    'guide.avoidAfter': 'Avoid planting after',
    'guide.goodPreviousCrops': 'Good previous crops',
    'guide.extraTips': 'Extra tips',
    'guide.sowing': 'Sowing',
    'guide.transplanting': 'Transplanting',
    'guide.spacing': 'Spacing',
    'guide.sowingDepth': 'Sowing depth',
    'guide.watering': 'Watering',
    'guide.feeding': 'Feeding',
    'guide.harvest': 'Harvest',
    'guide.goodToKnow': 'Good to know',
    'guide.difficulty.Easy': 'Easy',
    'guide.difficulty.Moderate': 'Moderate',
    'guide.difficulty.Advanced': 'Advanced',
  },
  lt: {
    'guide.searchPlaceholder': 'Ieškoti',
    'guide.noMatch': 'Nėra daržovių pagal „{query}“.',
    'guide.intro': 'Paprasti, neprisijungus veikiantys populiarių augalų priežiūros patarimai.',
    'guide.allVegetables': 'Visos daržovės',
    'guide.selectPrompt': 'Pasirinkite daržovę, kad pamatytumėte priežiūros gidą.',
    'guide.diseaseSearchPlaceholder': 'Ieškoti ligų ir kenkėjų',
    'guide.diseaseNoMatch': 'Nėra problemų pagal „{query}“.',
    'guide.diseaseIntro': 'Atpažinkite, gydykite ir išvenkite dažnų daržo problemų.',
    'guide.allDiseases': 'Visos problemos',
    'guide.diseaseSelectPrompt': 'Pasirinkite problemą, kad pamatytumėte gidą.',
    'guide.problemCategory.disease': 'Ligos',
    'guide.problemCategory.pest': 'Kenkėjai',
    'guide.problemCategory.disorder': 'Sutrikimai',
    'guide.overview': 'Apžvalga',
    'guide.difficultyLabel': 'Sunkumas',
    'guide.growingSeason': 'Vegetacijos sezonas',
    'guide.timeToHarvest': 'Laikas iki derliaus',
    'guide.idealConditions': 'Idealios augimo sąlygos',
    'guide.sun': 'Saulė',
    'guide.sunlight': 'Apšvietimas',
    'guide.soil': 'Dirvožemis',
    'guide.temperature': 'Temperatūra',
    'guide.water': 'Drėgmė',
    'guide.planting': 'Sodinimas',
    'guide.care': 'Priežiūra',
    'guide.support': 'Tvirtinimas',
    'guide.maintenance': 'Priežiūros darbai',
    'guide.generalTips': 'Bendri auginimo patarimai',
    'guide.commonProblems': 'Dažnos problemos',
    'guide.good': 'Tinka',
    'guide.backToGuide': 'Atgal į gidą',
    'guide.problemNotFound': 'Šios problemos gidas nerastas.',
    'guide.problemWhatIsIt': 'Kas tai',
    'guide.problemIdentify': 'Kaip atpažinti',
    'guide.problemWhy': 'Kodėl atsiranda',
    'guide.problemFix': 'Kaip taisyti',
    'guide.problemPrevent': 'Kaip išvengti',
    'guide.problemPlantsAffected': 'Pažeidžiami augalai',
    'guide.companionPlants': 'Geros kaimynės',
    'guide.goodCompanions': 'Tinkami kaimynai',
    'guide.avoid': 'Vengti',
    'guide.cropRotation': 'Sėjomaina',
    'guide.family': 'Šeima',
    'guide.avoidAfter': 'Nesodinti po',
    'guide.goodPreviousCrops': 'Tinkamos ankstesnės kultūros',
    'guide.extraTips': 'Papildomi patarimai',
    'guide.sowing': 'Sėja',
    'guide.transplanting': 'Persodinimas',
    'guide.spacing': 'Atstumas',
    'guide.sowingDepth': 'Sėjimo gylis',
    'guide.watering': 'Laistymas',
    'guide.feeding': 'Tręšimas',
    'guide.harvest': 'Derliaus nuėmimas',
    'guide.goodToKnow': 'Verta žinoti',
    'guide.difficulty.Easy': 'Lengva',
    'guide.difficulty.Moderate': 'Vidutiniška',
    'guide.difficulty.Advanced': 'Sudėtinga',
  },
};

export default guide;
